<template>
  <div class="gdpr-toast-container" v-if="showToast">
    <div class="gdpr-toast-container__toast">
      <GDPRToast :description="settings.gdpr_brief">
        <template v-slot:left>
          <TextButton @click="agreeHandle" title="sutinku" accent small />
          <TextButton @click="_setModalData" title="taisyklės" accentG small />
        </template>
      </GDPRToast>
    </div>
  </div>
</template>

<script>
import { setConstentCookie } from "@/utils";
import { mapState, mapActions } from "vuex";

import GDPRToast from "@/components/GDPRToast";
import TextButton from "@/components/TextButton";

export default {
  name: "GDPRToastContainer",
  components: {
    GDPRToast,
    TextButton
  },
  methods: {
    ...mapActions({
      setModalData: "setModalData"
    }),
    agreeHandle: function() {
      setConstentCookie();
    },
    _setModalData: function() {
      this.setModalData({
        content: this.settings.gdpr_description,
        close_label: this.settings.gdpr_close
      });
    }
  },
  computed: {
    ...mapState({
      consent: state => state.Analytics.consent,
      settings: state => state.settings
    }),
    showToast: function() {
      if (this.consent === false) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.gdpr-toast-container {
  &__toast {
    animation: appearGdprMobile 1.2s 3s forwards ease;
    top: 0;
    display: block;
    justify-content: flex-end;
    opacity: 0;
    padding: spacer("m");
    position: fixed;
    right: 0;
    transform: translateY(100%);
    width: 100%;
    z-index: z-index("gdpr");

    @include if-tablet {
      animation: appearGdpr 1.2s 3s forwards ease;
      bottom: spacer("m");
      padding: 0;
      right: spacer("m");
      top: auto;
      width: 350px;
    }

    @keyframes appearGdprMobile {
      0% {
        opacity: 0;
        transform: translateY(-100%);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes appearGdpr {
      0% {
        opacity: 0;
        transform: translateY(100%);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
}
</style>
